/** student/certificates — KEYS. */
export const studentCertificatesKeys = {
  all: () => ['student', 'certificates'] as const,
  status: (campaignId: string) => [...studentCertificatesKeys.all(), 'status', campaignId] as const,
  validate: (token: string) => [...studentCertificatesKeys.all(), 'validate', token] as const,
};
